<template>
  <el-dialog
    title="Редактировать прибор"
    :visible="visible"
    :before-close="close"
    @opened="onOpen"
  >
    <el-form ref="editForm" :rules="editFormRules" :model="editForm">
      <el-form-item label="Название" prop="name">
        <el-input name="name" ref="autoFocus" placeholder="Введите имя прибора..." v-model="editForm.name"></el-input>
      </el-form-item>
      <el-form-item label="Тип" prop="type" v-if="editForm.type == 140">
        <el-select v-model="editForm.type" class="modal-body__select">
          <el-option value="20" label="1" />
          <el-option value="40" label="2" />
          <el-option value="60" label="3" />
        </el-select>
      </el-form-item>

    </el-form>

    <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loadEditForm" @click="saveForm">Сохранить и закрыть</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogItemEdit',
  data () {
    return {
      form: null,
      error: null,
      loadEditForm: !!0,
      editForm: {
        type: '20'
      },
      editFormRules: {
        name: [
          { required: true, message: 'Укажите имя', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите тип', trigger: 'blur' }],
        compendium: [
          { required: true, message: 'Выберите тип', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
  },
  props: {
    visible: {
      required: true
    }
  },
  methods: {
    onOpen () {
      this.autoFocus()
    },
    close () {
      this.$emit('close')
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    saveForm (close) {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loadEditForm = !!1

          const payLoad = {
            type: this.editForm.type,
            schema: {
              text: this.editForm.name,
              compendium: this.editForm.compendium
            }
          }
          this.$api.device
            .edit(this.editForm.id, payLoad)
            .then(() => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })
              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.editForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message
              })
            })
            .finally(() => {
              this.loadEditForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  &__mask {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  &__wrapper {
    display: table-cell;
    vertical-align: middle;
  }
}

.modal-content {
  max-width: 700px;
  height: 90%;
  margin: 0 auto;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow-y: auto;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-body {
  max-width: 960px;
  margin: 20px auto;

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }
  &__btns {
    float: right;
  }
}

.modal-header {
  font-size: 24px;
  margin: 0;
  color: #5574a1;

  &__icon {
    float: right;
    cursor: pointer;
  }
}
.modal-footer {
  padding: 40px 0;

  &__button {
    float: right;
  }
}
</style>
